import React from "react";

 const Pin = ({color ="red" , style , bigSize ,selected =false}) => {

    return  selected ?  <svg
      width={ "29" }
      height={ "47" }
      viewBox="0 0 29 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style }}
    >
      <mask id="path-1-outside-1" maskUnits="userSpaceOnUse" x="0.171875" y="0.317627" width="29" height="46" fill="black">
        <rect fill="white" x="0.171875" y="0.317627" width="29" height="46"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M15.3941 25.485C21.0089 24.9275 25.3941 20.1902 25.3941 14.4287C25.3941 8.29224 20.4195 3.31763 14.283 3.31763C8.14649 3.31763 3.17188 8.29224 3.17188 14.4287C3.17188 20.1902 7.55707 24.9275 13.1719 25.485V42.2065C13.1719 42.8202 13.6693 43.3176 14.283 43.3176C14.8966 43.3176 15.3941 42.8202 15.3941 42.2065V25.485Z"/>
      </mask>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.3941 25.485C21.0089 24.9275 25.3941 20.1902 25.3941 14.4287C25.3941 8.29224 20.4195 3.31763 14.283 3.31763C8.14649 3.31763 3.17188 8.29224 3.17188 14.4287C3.17188 20.1902 7.55707 24.9275 13.1719 25.485V42.2065C13.1719 42.8202 13.6693 43.3176 14.283 43.3176C14.8966 43.3176 15.3941 42.8202 15.3941 42.2065V25.485Z" fill={color}/>
      <path d="M15.3941 25.485L15.0977 22.4997L12.3941 22.7681V25.485H15.3941ZM13.1719 25.485H16.1719V22.7681L13.4683 22.4997L13.1719 25.485ZM25.3941 14.4287H22.3941C22.3941 18.6328 19.1933 22.093 15.0977 22.4997L15.3941 25.485L15.6905 28.4703C22.8245 27.762 28.3941 21.7476 28.3941 14.4287H25.3941ZM14.283 3.31763V6.31763C18.7626 6.31763 22.3941 9.94909 22.3941 14.4287H25.3941H28.3941C28.3941 6.63539 22.0763 0.317627 14.283 0.317627V3.31763ZM3.17188 14.4287H6.17187C6.17187 9.94909 9.80334 6.31763 14.283 6.31763V3.31763V0.317627C6.48963 0.317627 0.171875 6.63539 0.171875 14.4287H3.17188ZM13.1719 25.485L13.4683 22.4997C9.37267 22.093 6.17187 18.6328 6.17187 14.4287H3.17188H0.171875C0.171875 21.7476 5.74147 27.762 12.8755 28.4703L13.1719 25.485ZM13.1719 42.2065H16.1719V25.485H13.1719H10.1719V42.2065H13.1719ZM14.283 43.3176V40.3176C15.3262 40.3176 16.1719 41.1633 16.1719 42.2065H13.1719H10.1719C10.1719 44.477 12.0125 46.3176 14.283 46.3176V43.3176ZM15.3941 42.2065H12.3941C12.3941 41.1633 13.2398 40.3176 14.283 40.3176V43.3176V46.3176C16.5535 46.3176 18.3941 44.477 18.3941 42.2065H15.3941ZM15.3941 25.485H12.3941V42.2065H15.3941H18.3941V25.485H15.3941Z" fill="#1080FF" fillOpacity="0.4" mask="url(#path-1-outside-1)"/>
      <circle cx="14.2865" cy="14.4287" r="3.33333" fill="white"/>
    </svg> :  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={bigSize ? "30" : "20"}
    height={bigSize ? "54" : "36"} 
    fill="none"
    viewBox="0 0 21 37"
    style={{...style}}
 

  >
    <path
    fill={color}
      d="M9.277 19.318a1 1 0 112 0v13a1 1 0 11-2 0v-13z"
    ></path>
    <circle cx="10.277" cy="10.318" r="10" fill={color}></circle>
    <circle cx="10.277" cy="10.318" r="3" fill="#fff"></circle>
  </svg>


};

export default Pin



